import { useMemo } from 'react';

import cx from 'classnames';

import { IUser } from 'utils/token';

import s from './UserAvatar.module.scss';

interface IProps {
  user: IUser;
  isActive?: boolean;
}

const UserAvatar: React.FC<IProps> = ({ user, isActive = false }) => {
  const userInitials = useMemo(() => {
    if (!user.name) return '';

    const nameArray = user.name.split(' ');

    const firstInitial = nameArray[0].slice(0, 1);
    const lastInitial = nameArray[1] ? nameArray[1].slice(0, 1) : '';

    return `${firstInitial} ${lastInitial}`;
  }, [user]);

  return (
    <span
      className={cx(s.item, {
        [s.active]: isActive,
      })}
    >
      <span className={s.initials}>{userInitials}</span>
    </span>
  );
};

export default UserAvatar;
